import '../view-services/account-view-services.module';
import ArchivedAccountListComponent from './archived-account-list.component';

angular.module('archivedAccounts', [ 'accountViewServices' ])
  .component('archivedAccountList', ArchivedAccountListComponent);

export const moduleName = 'archivedAccounts';
export default {
  moduleName,
};